import { createI18n } from "vue-i18n";

import en from "./locales/en";
import rw from "./locales/rw";

const supportedLocales = ["en", "rw"];

const savedLocale = localStorage.getItem("locale");

const defaultLocale = supportedLocales.includes(savedLocale)
  ? savedLocale
  : "en";

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: defaultLocale,
  fallbackLocale: "en",

  messages: {
    en,
    rw,
  },
});

document.documentElement.lang = defaultLocale;

export default i18n;